import React from 'react';
import { useHistory } from 'react-router-dom';

import Header from '../../components/Header';
import Layout from '../../components/Layout';

const Success = () => {
	const history = useHistory();
	const onBackButtonEvent = React.useCallback(
		() => history.push('/outlet-crew-success'),
		[history],
	);

	React.useEffect(() => {
		window.history.pushState(null, null, window.location.pathname);
		window.addEventListener('popstate', onBackButtonEvent);
		return () => {
			window.removeEventListener('popstate', onBackButtonEvent);
		};
	}, [onBackButtonEvent]);

	return (
		<div className="flex flex-col min-h-screen overflow-hidden">
			<Header title="Yummy Outlet Stock Management" type="outletcrew" />
			<Layout>
				<div className="flex items-center justify-center min-h-screen">
					<div className="m-auto">
						<div className="flex justify-center items-center mb-8">
							<img src="/images/success.svg" className="w-18 h-auto" />
						</div>
						<div className="text-center">
							<div className="laptop:text-extraLarge tablet:text-extraLarge mobile:large text-gray-gray700 font-interMedium uppercase">
								Berhasil Mengisi Stocktake
							</div>
							<div className="laptop:w-96 tablet:w-96 mobile:w-78 mt-3">
								<p className="laptop:text-large tablet:text-large mobile:text-regular text-gray-gray600 font-interRegular">
									Sesi ini telah berakhir
								</p>
							</div>
						</div>
					</div>
				</div>
			</Layout>
		</div>
	);
};

export default Success;
